class FeedBatch {
    feedSuccessActions: string[] = [];
    feedPromises: Promise<any>[] = [];

    addFeed( feedSuccessAction: string, feedPromise: Promise<any> ) {
        this.feedSuccessActions.push(feedSuccessAction);
        this.feedPromises.push(feedPromise);
    }

    all( dispatch: ( action: any ) => void ) {
        return new Promise<void>( (resolve, reject) =>
            Promise.all(this.feedPromises)
                .then( ( responses: any[] ) => {
                    for( let i = 0; i < this.feedSuccessActions.length; i++ ) {
                        dispatch( { type: this.feedSuccessActions[i], data: responses[i].data, headers: responses[i].headers } );
                    }
                    resolve();
                } )
                .catch( error => reject(error) )
        );
    }
}

export default FeedBatch;
